import TabsConnector from './tabs.props';
import TabsComponent from './tabs.component';

export default TabsConnector(TabsComponent);
